module.exports = __webpack_public_path__ + "img/Webp.net-resizeimage.a970dab3.png";